import {Component, importProvidersFrom, Injectable, OnInit} from '@angular/core';
import {SectionComponent} from "../../elements/section/section.component";
import {NgForOf} from "@angular/common";
import {FullScreenSliderComponent} from "../../elements/full-screen-slider/full-screen-slider.component";
import {ApiService} from "../../../services/api.service";
import {Article} from "../../../model/article";
import {getImageUrl} from "../../../functions/getImageUrl";
@Injectable({
    providedIn: 'root'
})
@Component({
  selector: 'app-article',
  standalone: true,
    imports: [
        NgForOf,
        FullScreenSliderComponent,
    ],
  templateUrl: './article.component.html',
  styleUrl: './article.component.scss',
})
export class ArticleComponent implements OnInit {
    constructor(
        private fullScreenSliderComponent: FullScreenSliderComponent,
        private apiService: ApiService
        ) {}

    slides: string[] = [
      'app/assets/newspapers/1.jpeg',
      'app/assets/newspapers/2.png',
      'app/assets/newspapers/3.jpeg',
      'app/assets/newspapers/4.jpeg',
      'app/assets/newspapers/5.jpeg',
      'app/assets/newspapers/6.jpeg',
      'app/assets/newspapers/7.jpeg',
      'app/assets/newspapers/8.jpeg',
      'app/assets/newspapers/9.jpeg',
  ];

    activeSlide: string = this.slides[0];

    active: boolean = false;
    loading: boolean = false;

    activeIndex: number = 0;

    ngOnInit() {
        this.loading = false;
        this.apiService.getPaginatedData('public/newspaper', 1, 1000, '').subscribe((data) => {
            this.slides = data.content.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((v: any) => v.image.toString());
            setTimeout(() => {
                this.loading = false;
            }, 0);
        })
    }

    open(index: number, slide: string): void {
       setTimeout(() => {
           this.activeSlide = slide;
           this.active = !this.active;
       }, 100);
    }

    clickSlider(type: string) {
        let newIdx;
        if (type == 'left') {
            newIdx = this.activeIndex - 1;
            if (newIdx < 0) {
                newIdx = this.slides.length - 1;
            }
        } else {
            newIdx = this.activeIndex + 1;
            if (newIdx > this.slides.length - 1) {
                newIdx = 0;
            }
        }
        this.activeIndex = newIdx;
        this.activeSlide = this.slides[newIdx];
    }

    protected readonly getImageUrl = getImageUrl;
}
